import { lazy } from "react";
import { DCPPathNames } from "../../../utilities/Constants";
import { AppRoute } from "../../../models/AppRoute";

//#region - Lazy-loaded component
const UserProfile = lazy(() => import("../views/UserProfile"));
//#endregion

const accountRoutes: AppRoute[] = [
    {
        path: DCPPathNames.PROFILE_PATH,
        name: "Profile",
        element: <UserProfile />,
        meta: {
            requiresAuthorization: false,
        },
    },
];

export default accountRoutes;
